import React from "react";

export const UsedIcon = ({
  size = "22",
  color = "#36F99F",
  colorStrokeCircle = "white",
  colorStrokeCheck = "white"
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 22 23"
      fill="none"
    >
      <circle
        cx="11.077"
        cy="11.3831"
        r="10"
        fill={color}
        stroke={colorStrokeCircle}
        strokeWidth="1.53846"
      />
      <path
        d="M14.4102 9.07812L9.4743 14.014L7.23071 11.7704"
        stroke={colorStrokeCheck}
        strokeWidth="1.15385"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
